import { useCallback, useRef } from 'react';

export function useForceRestartWithAudio(
  videoRef: React.RefObject<HTMLVideoElement>,
  audioRef: React.RefObject<HTMLAudioElement>,
) {
  const running = useRef(false);

  const restart = useCallback(async () => {
    const video = videoRef.current;
    const audio = audioRef.current;

    const isSafari = /^((?!chrome|android).)*safari/i.test(navigator.userAgent);

    if (!video || !audio || !isSafari || running.current) return;

    running.current = true;

    try {
      // Wait for any in-progress play to settle (prevents silent pause failure)
      await video.play().catch(() => {});

      video.pause();
      audio.pause();

      const currentTime = video.currentTime;

      audio.currentTime = currentTime;
      video.currentTime = currentTime;

      await Promise.all([audio.play().catch(() => {}), video.play().catch(() => {})]);
    } catch (err) {
      console.warn('Force restart failed:', err);
    } finally {
      running.current = false;
    }
  }, [videoRef, audioRef]);

  return restart;
}
